// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SplitPanelIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="SplitPanelIcon" ref={forwardedRef} {...props}>
      <path d="M16.603 3.005A1 1 0 0 1 17.5 4v12l-.005.102a1 1 0 0 1-.893.893L16.5 17h-13l-.103-.005a1 1 0 0 1-.892-.893L2.5 16V4a1 1 0 0 1 .897-.995L3.5 3h13zM12.5 15.5H16v-11h-3.5zm-8.5 0h7v-11H4z" />
    </SvgIcon>
  );
});

/**
 * Use to switch to the split panel
 * @public
 */
export const SplitPanelIcon = /* @__PURE__ */ Object.assign(
  SplitPanelIconComponent,
  { displayName: 'SplitPanelIcon' },
);
